const permissions = {
  listProtocol: 'PT001',
  createProtocol: 'PT002',
  editProtocol: 'PT003',
  deleteProtocol: 'PT004'
};

export default permissions;
